var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('span', {
    staticClass: "AnimatedIcon",
    style: {
      'width': ((_vm.size) + "px"),
      'height': ((_vm.size) + "px")
    }
  }, [_c('span', {
    ref: "loaderElement"
  })]);
}
var staticRenderFns = []

export { render, staticRenderFns }